import { List as MuiList } from '@mui/material';
import { styled } from '@mui/material/styles';

const List = styled(MuiList)({
  '& .MuiListItemButton-root': {
    color: 'lightGrey',
    margin: '5px',
    borderRadius: '25px',
    '&, & .MuiListItemIcon-root': {
      color: 'lightGrey',
    },
  },
  // selected and (selected + hover) states
  '&& .Mui-selected, && .Mui-selected:hover': {
    backgroundColor: '#ef5350',
    '&, & .MuiListItemIcon-root': {
      color: 'lightGrey',
    },
  },
  // hover states
  '& .MuiListItemButton-root:hover': {
    backgroundColor: '#ef5350',
    '&, & .MuiListItemIcon-root': {
      color: 'lightGrey',
    },
  },
});

export default List;
